import { FaFacebook, FaInstagram } from "react-icons/fa";
import { ButtonLink } from "../molecules/Button";

const sns = [
  {
    name: "X",
    href: "https://x.com/toccasystems",
    className: "mr-2 group-hover:text-hov text-sns-x",
    icon: () => (
      <svg width="20" height="20" viewBox="0 0 1200 1227" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" />
      </svg>
    ),
  },
  {
    name: "Instagram",
    href: "https://www.instagram.com/toccasystems/",
    className: "mr-2 group-hover:text-hov text-sns-instagram",
    icon: FaInstagram,
  },
  {
    name: "Facebook",
    href: "https://www.facebook.com/toccasystems/",
    className: "mr-2 group-hover:text-hov text-sns-facebook",
    icon: FaFacebook,
  },
];

export const TopSNS = () => {
  return (
    <>
      <div className="relative mx-auto box-border flex max-w-7xl flex-col justify-between gap-2 px-6 text-txt-base sm:px-8 md:px-12 lg:flex-row lg:items-start xl:px-0">
        <h6 className="font-bold text-pri fluid-text-[16px,22px] ">SNS</h6>
        <div className="md:max-w-[616px]">
          <h3 className="font-bold leading-comfort text-txt-base fluid-text-[14px,18px] ">
            トッカシステムズでは各種SNSにて、社内の日常から技術情報まで、さまざまな情報を発信しています
          </h3>
        </div>
      </div>
      <div className="mx-auto mt-6 box-border grid max-w-7xl grid-cols-3 gap-2 px-6 sm:px-8 md:mt-8 md:grid-cols-3 md:gap-5 md:px-12 lg:mt-10 xl:px-0">
        {sns.map((user) => (
          <div className="col-span-1" key={user.index}>
            <ButtonLink
              href={user.href}
              target="_blank"
              variant="outline"
              color="qua"
              className="h-[48px] w-full rounded-md fluid-text-[12px,16px] md:h-[64px]"
            >
              <user.icon className={user.className} aria-hidden="true" />
              {user.name !== "X" && user.name}
            </ButtonLink>
          </div>
        ))}
      </div>
    </>
  );
};
